import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { translate } from 'containers/services/translate';
import { JUDGEMENT_ADD_DOCUMENT } from 'containers/data-structure';
import { handleOpenDocument } from 'services/utils';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/messages';
import View from 'components/SahamIcons/View';
import Document from 'components/Document';

export interface DocumentRecapProps {
  intl: IntlShape;
  judgementAddDocuments: JudgementADDDocumentType;
  requestGetDocByDocumentumId: Function;
}

const DocumentRecap: React.FC<DocumentRecapProps> = (props): JSX.Element => {
  const { judgementAddDocuments } = props;

  return (
    <section className="document-recap">
      <div className="document-recap-title">
        {translate(messages.uploadedDocument, props)}
      </div>
      <Document
        name={judgementAddDocuments[JUDGEMENT_ADD_DOCUMENT.NAME]}
        type={judgementAddDocuments[JUDGEMENT_ADD_DOCUMENT.TYPE]}
        icon={
          <div
            className="consult"
            onClick={handleOpenDocument(
              judgementAddDocuments,
              props.requestGetDocByDocumentumId,
            )}
          >
            <View />
          </div>
        }
      />
    </section>
  );
};

export default injectIntl(DocumentRecap);
